import * as $http from 'axios';
import weui from 'weui.js';
const URL = config.configURL;
const AuthorizeUrl = config.authorizeUrl;


/**
 * 缓存信息说明
 * 微信唯一标识：openid
 * 院区ID:hosid
 * 用户id：userid
 * 卡详情：cardinfo
 */

export const SetItem = (name, value) => {
  localStorage.setItem(name, value);
};
export const GetItem = (name) => {
  return localStorage.getItem(name);
};

export const RemoveItem = (name) => {
  localStorage.removeItem(name);
};

/**
 * 获取微信用户CODE
 *
 * 无
 *
 * @param    {string}      userCode     连接CODE
 * @returns  JsonString
 *
 * @date     2018年6月11日 11:18:31
 * @author   何佳徽
 */
export const GetOpenId = (userCode) => {
  var code = {
    Code: userCode
  }
  return $http.post(URL + 'GetOpenId', code);
}

/**
 * 获取院区
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2018年6月11日 11:18:31
 * @author   何佳徽
 */
export const GetHost = () => {
  return $http.post(URL + "GetHost");
}

/**
 * 根据OPENID获取用户信息
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月22日 14:00:31
 * @author   何佳徽
 */
export const GetUserInfoByOpenID = () => {
  var para = {
    OpenID: GetItem("openid")
  };
  return $http.post(URL + "GetUserInfoByOpenID", para);
};

/**
 * 新增或修改用户资料
 *
 * 无
 *
 * @param    {string}  UserID            用户ID
 * @param    {string}  Name              患者姓名
 * @param    {string}  sex               性别
 * @param    {string}  phoneNumber       电话
 * @param    {string}  regionStr         地址
 * @returns  JsonString
 *
 * @date     2018年6月11日 11:18:31
 * @author   何佳徽
 */
export const AddOrUpdateUser = (name, sex, phoneNumber, credentialNumber, qrCode, regionStr) => {
  var para = {
    Name: name,
    Sex: sex,
    PhoneNumber: phoneNumber,
    OpenId: GetItem("openid"),
    IDNumber: credentialNumber,
    HosID: GetItem("hosid"),
    QRCode: qrCode,
    RegionStr: regionStr
  };
  return $http.post(URL + "AddOrUpdateUser", para);
}

/**
 * 用户绑卡
 *
 * 无
 *
 * @param    {string}  UserID            用户ID
 * @param    {string}  Name              患者姓名
 * @param    {string}  CredentialNumber  身份证
 * @param    {string}  CardNumber        卡号
 * @returns  JsonString
 *
 * @date     2019年4月23日 14:18:28
 * @author   何佳徽
 */
export const BinDingCard = (name, credentialNumber, cardNumber, phoneNumber) => {
  var para = {
    UserID: GetItem("userid"),
    Name: name,
    IDNumber: credentialNumber,
    CardNumber: cardNumber,
    HosID: GetItem("hosid"),
    PhoneNumber: phoneNumber,
    OpenId: GetItem("openid")
  };
  return $http.post(URL + "BinDingCard", para);
};


/**
 * 根据openid获取所有卡信息
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date      2019年4月24日 14:30:25
 * @author   何佳徽
 */
export const GetAllCardByOpenID = () => {
  var para = {
    OpenID: GetItem("openid")
  };
  var a = $http;
  // debugger

  return $http.post(URL + "GetAllCardByOpenID", para);
}

/**
 * 获取预计就诊时间
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date      2019年4月24日 14:30:25
 * @author   何佳徽
 */
export const GetEstimatedTime = (dptID, dctID, time, scheRecoDetaID) => {
  var para = {
    DptID: dptID,
    DctID: dctID,
    StartTime: time,
    HosID: GetItem("hosid"),
    ScheRecoDetaID: scheRecoDetaID
  };
  return $http.post(URL + "GetEstimatedTime", para);
}

/**
 * 更换默认卡号
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 21:00:12
 * @author   何佳徽
 */
export const DefultUserCard = (patID) => {
  var para = {
    OpenID: GetItem("openid"),
    PatID: patID
  }
  return $http.post(URL + "DefultUserCard", para);
}

/**
 * 获取微信信息
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 21:00:12
 * @author   何佳徽
 */
export const GetWXUserInfo = () => {
  var para = {
    OpenID: GetItem("openid")
  }
  return $http.post(URL + "GetWXUserInfo", para);
}

/**
 * 解除绑定
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月24日 17:27:24
 * @author   何佳徽
 */
export const UntyingUserCard = (patID) => {
  var para = {
    OpenID: GetItem("openid"),
    PatID: patID
  }
  return $http.post(URL + "UntyingUserCard", para);
}

/**
 * 获取收费
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月24日 17:27:24
 * @author   何佳徽
 */
export const GetChargeItemByVisitID = (visitID) => {
  var para = {
    VisitID: visitID
  }
  return $http.post(URL + "GetChargeItemByVisitID", para);
}

/**
 * 获取可挂号科室
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2019年4月19日 14:57:00
 * @author   何佳徽
 */
export const GetRegDept = () => {
  var para = {
    HosID: GetItem("hosid")
  };
  return $http.post(URL + "GetRegDept", para);
};

/**
 * 获取医生头像
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2019年4月19日 14:57:00
 * @author   何佳徽
 */
export const GetDctImg = (id) => {
  //var para = {
  //  //HosID: GetItem("hosid")
  //  id: id
  //};
  return $http.get(URL + "GetDctImg?id=" + id);
};

/**
 * 获取科室下医生列表
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2019年4月19日 14:57:03
 * @author   何佳徽
 */
export const GetRegDctByDptID = (dptID, keywords) => {
  var para = {
    DptID: dptID,
    KeyWords: keywords,
    HosID: GetItem("hosid")
  };
  return $http.post(URL + "GetRegDctByDptID", para);
};

/**
 * 获取一个医生的排班信息
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2019年4月22日 19:34:02
 * @author   何佳徽
 */
export const GetSchedulingByDctID = (doctorID,dateTime) => {
  var para = {
    DctID: doctorID,
    HosID: GetItem("hosid"),
    SearchDate:dateTime
  };
  return $http.post(URL + "GetSchedulingByDctID", para);
};

/**
 * 更新一个医生的排班信息
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2019年4月22日 19:34:02
 * @author   何佳徽
 */
export const UpdateSchedulingByDctID = (doctorID,time) => {
  var para = {
    DctID: doctorID,
    Time:time,
    HosID: GetItem("hosid")
  };
  return $http.post(URL + "UpdateSchedulingByDctID", para);
};

/**
 * 新增挂号
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 10:44:26
 * @author   何佳徽
 */
export const AddReg = (dctID, visitTime, scheRecoDetaID) => {
  var data = {
    DctID: dctID,
    PatID: GetItem("patid"),
    VisitTime: visitTime,
    ScheRecoDetaID: scheRecoDetaID,
    HosID: GetItem("hosid")
  };
  return $http.post(URL + "AddReg", data);
}


/**
 * 获取某个时间段内的就诊信息
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetVisits = (type) => {
  var data = {
    type: type,
    PatID: GetItem("patid")
  };
  return $http.post(URL + "GetVisits", data);
}


/**
 * 获取某个时间段内的挂号信息
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetRegisterListByPatID = (type) => {
  var data = {
    TimeType: type,
    PatID: GetItem("patid")
  };
  return $http.post(URL + "GetRegisterListByPatID", data);
}

/**
 * 获取个人中心挂号详情
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetRegInfoByRegID = (regID) => {
  var data = {
    RegID: regID
  };
  return $http.post(URL + "GetRegInfoByRegID", data);
}

/**
 * 获取个人中心收费列表
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetChargeListByPatID = (type) => {
  var data = {
    TimeType: type,
    PatID: GetItem("patid")
  };
  return $http.post(URL + "GetChargeListByPatID", data);
}


/**
 * 获取个人中心收费列表
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const ChargeSuccess = (chargeID, visitID) => {
  var data = {
    ChargeID: chargeID,
    VisitID: visitID
  };
  // debugger;
  return $http.post(URL + "ChargeSuccess", data);
}

/**
 * 获取满意度选项
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetInvestigationByHosID = (hosid) => {
  var data = {
    HosID: hosid
  };
  return $http.post(URL + "GetInvestigationByHosID", data);
}


/**
 * 新增满意度调查
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const AddInvestigation = (visitID, wxInvestigationData, proposal, phone) => {
  var data = {
    PatID: GetItem("patid"),
    VisitID: visitID,
    WXInvestigationData: wxInvestigationData,
    Proposal: proposal,
    Phone: phone
  };
  return $http.post(URL + "AddInvestigation", data);
}

/**
 * 候诊信息
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetReferralList = () => {
  var data = {
    PatID: GetItem("patid")
  };
  return $http.post(URL + "GetReferralList", data);
}

/**
 * 获取报告列表
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetPresentationAll = (timeType) => {
  var data = {
    TimeType: timeType,
    PatID: GetItem("patid")
  };
  return $http.post(URL + "GetPresentationAll", data);
}

/**
 * 获取检查报告
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetCheckPresentation = (presentationID) => {
  var data = {
    PresentationID: presentationID
  };
  return $http.post(URL + "GetCheckPresentation", data);
}


/**
 * 检验报告
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetExamPresentation = (presentationID) => {
  var data = {
    PresentationID: presentationID
  };
  return $http.post(URL + "GetExamPresentation", data);
}


/**
 * 评定报告
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetEvaPresentation = (presentationID) => {
  var data = {
    PresentationID: presentationID
  };
  return $http.post(URL + "GetEvaPresentation", data);
}

/**
 * 评定报告PDF
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetEvaPlanPDF = (presentationID) => {
  var data = {
    PresentationID: presentationID
  };
  return $http.post(URL + "GetEvaPlanPDF", data);
}

/**
 * 获取患者治疗医嘱信息
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetTreatMedicalOrder = (visitID) => {
  var data = {
    PatID: GetItem("patid"),
    VisitID: visitID
  };
  return $http.post(URL + "GetTreatMedicalOrder", data);
}

/**
 * 获取患者治疗详情信息
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetTreatedRecord = (visitID, moID) => {
  var data = {
    PatID: GetItem("patid"),
    VisitID: visitID,
    MoID: moID
  };
  return $http.post(URL + "GetTreatedRecord", data);
}

/**
 * 获取  下所有的科室
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetDpetAll = (keyWords) => {
  var data = {
    HosID: GetItem("hosid"),
    KeyWords: keyWords
  };
  return $http.post(URL + "GetDpetAll", data);
}

export const GetHostInfoByID = () => {
  var data = {
    HosID: GetItem("hosid")
  };
  return $http.post(URL + "GetHostInfoByID", data);
}

export const GetDptSynopsis = (dptID) => {
  var data = {
    DptID: dptID
  };
  return $http.post(URL + "GetDptSynopsis", data);
}

/**
 * 挂号成功页面
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const GetRegSuccess = (regID) => {
  var data = {
    RegID: regID
  };
  return $http.post(URL + "GetRegSuccess", data);
}

/**
 * 取消预约
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月28日 14:03:06
 * @author   何佳徽
 */
export const HISBackNumber = (regID) => {
  var data = {
    GUID: regID
  };
  return $http.post(URL + "HISBackNumber", data);
}

/**
 * 微信验证
 *
 * 无
 *
 * @param    {string}      url           验证服务器地址
 * @returns  JsonString
 *
 * @date     2019年4月30日 16:41:18
 * @author   何佳徽
 */
export const GetAuthorizeUrl = (parameter) => {
  var redirectUrl = {
    RedirectUrl: AuthorizeUrl + parameter
  }

  return $http.post(URL + 'GetAuthorizeUrl', redirectUrl);
}

/**
 * 组织挂号数据
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月30日 16:41:18
 * @author   何佳徽
 */
export const GetHISAddRegModel = (dptID, dctID, visitTime, scheRecoDetaID) => {
  var sendData = {
    PatID: GetItem("patid"),
    DptID: dptID,
    DctID: dctID,
    VisitTime: visitTime,
    ScheRecoDetaID: scheRecoDetaID,
    HosID: GetItem("hosid"),
    OpenID: GetItem("openid")
  }
  //type 1是收费  2是挂号
  var sendPayinfo = {
    OpenId: GetItem("openid"),
    HosID: GetItem("hosid"),
    PatID: GetItem("patid"),
    Type: 2,
    ChargeData: JSON.stringify(sendData)
  };
  //return $http.post(URL + 'HISAddReg', sendData);
  return sendPayinfo
};

/**
 * 组织收费数据
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月30日 16:41:18
 * @author   何佳徽
 */
export const GetHISAddChargeModel = (visitID, chargeItme, hosid) => {
  var sendData = {
    PatID: GetItem("patid"),
    ChargeItme: chargeItme,
    HosID: hosid,
    OpenID: GetItem("openid"),
    VisitID: visitID
  }
  //type 1是收费  2是挂号
  var sendPayinfo = {
    OpenId: GetItem("openid"),
    HosID: hosid,
    PatID: GetItem("patid"),
    Type: 1,
    ChargeData: JSON.stringify(sendData)
  };
  return sendPayinfo
};

/**
 * 微信收费
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月30日 16:41:18
 * @author   何佳徽
 */
export const AddHisCharge = (outOrder) => {
  var data = {
    OutOrder: outOrder
  }
  return $http.post(URL + 'AddHisCharge' + '?connect_redirect=1', data);
};

/**
 * 微信收费
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月30日 16:41:18
 * @author   何佳徽
 */
export const QueryOrderState = (outOrder, count) => {
  var data = {
    OutOrder: outOrder
  }
  const instance = $http.create({
    baseURL: URL,
    url: '/QueryOrderState',
    method: 'post',
  });
  count = count || 0;
  let retryCount = 0;
  instance.interceptors.response.use(function (response) {
    retryCount++;
    let retryDelay = 5000;
    let backoff = new Promise(function(resolve){
      setTimeout(function(){
        resolve();
      }, retryDelay);
    });
    if(retryCount >= count) {
      return Promise.reject(new Error('请求失败'));
    }

    if (!response.data.Result) {
      return backoff.then(function(){
        return instance.request(response.config);
      });
    } else {
      return response;
    }
  });
  return instance.post(URL + 'QueryOrderState', data);
};


/**
 * 微信挂号冲销
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月30日 16:41:18
 * @author   何佳徽
 */
export const DeletePayRecord = (outOrder) => {
  var data = {
    OutOrder: outOrder
  }
  return $http.post(URL + 'DeletePayRecord', data);
};



/**
 * 微信起吊收费
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月30日 16:41:18
 * @author   何佳徽
 */
export const WeiXinCharge = (chargeData) => {
  return new Promise(function (resolve, reject) {
    if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', OnBridgeReady(chargeData, resolve), false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', OnBridgeReady(chargeData, resolve));
        document.attachEvent('onWeixinJSBridgeReady', OnBridgeReady(chargeData, resolve));
      }
    } else {
      return OnBridgeReady(chargeData, resolve);
    }
  });
}

export const OnBridgeReady = (chargeData, resolve) => {
  $http.post(URL + 'GetPayConfig', chargeData).then((response) => {
    var a = response.data;
    if (!a.Result) {
      weui.dialog({
        title: "提示",
        content: a.Content
      });
      resolve('no_');
      return;
    }
    var weiXinData = JSON.parse(a.weiXinData);
    //resolve('ok' + "_" + a.OutTradeNo);
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
        "appId": weiXinData.appId,     //公众号名称，由商户传入
        "timeStamp": weiXinData.timeStamp,         //时间戳，自1970年以来的秒数
        "nonceStr": weiXinData.nonceStr, //随机串
        "package": weiXinData.package,
        "signType": "MD5",         //微信签名方式：
        "paySign": weiXinData.paySign//微信签名
      },
      function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          resolve('ok' + "_" + a.OutTradeNo);
          return;
        }
        else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          resolve('cancel' + "_" + a.OutTradeNo);
          return;
        }
        else if (res.err_msg == "get_brand_wcpay_request:fail") {
          resolve('fail' + "_" + a.OutTradeNo);
          return;
        }
      }
    );
  });
}

/**
 * 获取地址省份信息
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2020年5月8日 11:23:00
 * @author   万婷
 */
export const GetRegionInfo = () => {
  return $http.get(URL + "GetRegionInfo");
};

/**
 * 住院预约交金获取患者信息
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2020年6月23日 15:51:00
 * @author   谯俊杰
 */
export const GetIpPatInfo = (patID,hosID) => {
  var data = {PatID:patID,HosID:hosID};
  return $http.post(URL + "GetIpPatInfo",data);
};


/**
 * 判断能否收费
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2020年6月23日 15:51:00
 * @author   谯俊杰
 */
export const CanIpPayment = (ipNo,hosID) => {
  var data = {IpNo:ipNo,HosID:hosID};
  return $http.post(URL + "CanIpPayment",data);
};

/**
 * 获取住院列表
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2020年6月23日 15:51:00
 * @author   谯俊杰
 */
export const GetIpListByPatID = (patID,dateType) => {
  var data = {
    PatID:patID,
    DateType:dateType
  };
  return $http.post(URL + "GetIpListByPatID",data);
};

/**
 * 获取住院列表
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2020年6月23日 15:51:00
 * @author   谯俊杰
 */
export const GetIpPaymentRecordByIpNo = (ipNo,dateType) => {
  var data = {IpNo:ipNo,DateType:dateType};
  return $http.post(URL + "GetIpPaymentRecordByIpNo",data);
};

/**
 * 获取authCode retCode
 *
 * 描述：无
 *
 * @returns  JsonString
 *
 * @date     2020年6月23日 15:51:00
 * @author   谯俊杰
 */
export const GetPayData = (data) => {
  var data = data;
  return $http.post(URL + "GetPayData",data);
};
export const YBPayCallBck = (data) => {
  var data = data;
  return $http.post(URL + "YBPayCallBck", data);
};

export const GetMedicalInsuranceUrl = (data) => {
  return $http.post(URL + "GetMedicalInsuranceUrl",data);
};

export const NoSelfPayment = (data) => {
  return $http.post(URL + "NoSelfPayment",data);
};
export const GetUserCardNo = (data) => {
  return $http.post(URL + "GetUserCardNo",data);
};





/**
 * 微信起吊收费
 *
 * 无
 *
 * @returns  JsonString
 *
 * @date     2019年4月30日 16:41:18
 * @author   何佳徽
 */
export const WeiXinChargeTwo = (chargeData) => {
  return new Promise(function (resolve, reject) {
    if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', OnBridgeReadyTwo(chargeData, resolve), false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', OnBridgeReadyTwo(chargeData, resolve));
        document.attachEvent('onWeixinJSBridgeReady', OnBridgeReadyTwo(chargeData, resolve));
      }
    } else {
      return OnBridgeReadyTwo(chargeData, resolve);
    }
  });
}

export const OnBridgeReadyTwo = (chargeData, resolve) => {
  $http.post(URL + 'MedicalInsurancePaymentConfig', chargeData).then((response) => {
    var a = response.data;
    if (!a.Result) {
      weui.dialog({
        title: "提示",
        content: a.Content
      });
      resolve('no_');
      return;
    }
    var weiXinData = JSON.parse(a.weiXinData);
    //resolve('ok' + "_" + a.OutTradeNo);
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
        "appId": weiXinData.appId,     //公众号名称，由商户传入
        "timeStamp": weiXinData.timeStamp,         //时间戳，自1970年以来的秒数
        "nonceStr": weiXinData.nonceStr, //随机串
        "package": weiXinData.package,
        "signType": "MD5",         //微信签名方式：
        "paySign": weiXinData.paySign//微信签名
      },
      function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          resolve('ok' + "_" + a.OutTradeNo);
          return;
        }
        else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          resolve('cancel' + "_" + a.OutTradeNo);
          return;
        }
        else if (res.err_msg == "get_brand_wcpay_request:fail") {
          resolve('fail' + "_" + a.OutTradeNo);
          return;
        }
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/services/getData.js